"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectedMark = exports.label = exports.inputFontSizes = exports.input = exports.helper = exports.border = void 0;
var colors = _interopRequireWildcard(require("./colors"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// INFO Only thing that is used from this file is `selectedMark`. But we have to keep all because of generate CSS vars

const input = exports.input = {
  size: '1.6rem'
};
const label = exports.label = {
  size: '1.6rem'
};
const helper = exports.helper = {
  size: '1.6rem'
};
const border = exports.border = {
  color: colors.oriGrey[500]
};
const selectedMark = exports.selectedMark = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' style='width: 24px; height: 24px; fill: inherit'%3E%3Cpath d='M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0m12.351-2.144a.5.5 0 1 0-.702-.712l-4.708 4.65-2.13-1.686a.5.5 0 0 0-.621.784l2.825 2.234z'%3E%3C/path%3E%3C/svg%3E")`;
const inputFontSizes = exports.inputFontSizes = {
  input: {
    mobile: input.size
  },
  'input-label': {
    mobile: label.size
  },
  'input-helper': {
    mobile: helper.size
  }
};
//# sourceMappingURL=textInputData.js.map